module.exports = __webpack_public_path__ + "img/logo-centry-532x128-24.b40f67e2.png";